import React, { useEffect, useState } from "react";
import { withEmail } from "hocs/withEmail";
import Input from "../Input";

export const EmailInput = withEmail(({ email, onChange, ...props }) => {
    useEffect(() => {
        if (email && onChange) {
            // not sure if it might be required
            // throughout the app
            // if yes move it to the Input component
            // setting the default value doesn't trigger onChange
            onChange(email);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email]);

    const [val, setVal] = useState(email);
    const handleOnChange = val => {
       setVal(val);
       if (onChange) {
           onChange(val);
       }
    };


    return <Input
        {...props}
        type="email"
        value={val}
        onChange={handleOnChange}
        disabled={Boolean(email)}
    />;
});

export default EmailInput;
